import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { Tooltip } from "antd";
import SearchIcon from "@mui/icons-material/Search";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
// import { AiOutlineUserAdd } from "react-icons/ai";
// import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
	resetGetLoyaltyPointsList,
	getLoyaltyPointsListReq
} from "../../redux/actions/getLoyaltyPointsListAction";

import {
	resetGateLoyaltyPointOperationsList,
	gateLoyaltyPointOperationsListReq
} from "../../redux/actions/gateLoyaltyPointOperationsListAction";

import {
	resetCreateOrUpdateLoyaltyPoint,
	createOrUpdateLoyaltyPointReq
} from "../../redux/actions/createOrUpdateLoyaltyPointAction";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import AddLoyaltyService from "./AddLoyaltyService";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";

import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

import { getRegenerateToken } from "../../redux/actions/regenerateTokenAction";
import { getTransactionCurrencyListAction } from "../../redux/actions/getTransactionCurrencyList";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const LoyalPoints = () => {
	const [operationId, setoperationId] = useState("");
	const [amountCurrency, setamountCurrency] = useState("");
	const [unitAmount, setunitAmount] = useState("");
	const [loyaltyPoints, setloyaltyPoints] = useState("");
	const [amountValue, setamountValue] = useState("");
	const [minimumLoyaltyPointThreshold, setminimumLoyaltyPointThreshold] =
		useState("");

	const [notificationOpenSF, setNotificationOpenSF] = useState(false);
	const [udateLoyaltyPointStatus, setudateLoyaltyPointStatus] = useState(false);
	const [loyaltyPointId, setloyaltyPointId] = useState("");

	const [open, setOpen] = React.useState(false);
	const [operationName, setOperationName] = useState("");
	const [currency, setCurrency] = useState("");
	const [getLoyaltyListStatus, setGetLoyaltyListStatus] = useState(false);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [isLoading, setIsLoading] = useState(false);
	//closedManualOtpRequestListRes
	const [
		createOrUpdateLoyaltyPointResArray,
		setCreateOrUpdateLoyaltyPointResArray
	] = useState("");

	const [getLoyaltyPointsListArray, setGetLoyaltyPointsListArray] =
		useState("");

	const [rowsPerPage, setRowsPerPage] = useState(5);

	const [page, setPage] = useState(0);
	const classes = useStyles();

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
	var authToken = regenerateTokenRes.data.AuthToken;

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleNoticationCloseSF = () => {
		setNotificationOpenSF(false);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const createOrUpdateLoyaltyPointRes = useSelector(
		({ createOrUpdateLoyaltyPoint }) => createOrUpdateLoyaltyPoint
	);

	const getTransactionCurrencyListRes = useSelector(
		({ getTransactionCurrencyList }) => getTransactionCurrencyList
	);

	// Add login selector
	const login = useSelector((state) => state.login);

	// Add function
	const getTransactionCurrencyListFunc = () => {
		const requestData = {
			loginDetails: {
				walletOwnerId: login.data.partnerId,
			},
		};
		dispatch(getTransactionCurrencyListAction(requestData, authToken));
	};

	// Add useEffect
	useEffect(() => {
		getTransactionCurrencyListFunc();
	}, [regenerateTokenRes.data.status]);

	//console.log("createOrUpdateLoyaltyPointRes");
	//console.log(createOrUpdateLoyaltyPointRes);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "currency") {
			setCurrency(value == "Select Currency" ? "" : value);
			// setCurrency(value);
		}

		if (name === "operationName") {
			// setOperationName(value);
			setOperationName(value == "Select OperationType" ? "" : value);
		}

		if (name === "operationId") {
			setoperationId(value);
		}

		if (name === "amountCurrency") {
			setamountCurrency(value);
		}
		if (name === "unitAmount") {
			// setunitAmount(value);
			Util.verifyAmount(value)
				? setunitAmount(value)
				: setunitAmount(unitAmount);
		}

		if (name === "loyaltyPoints") {
			// setloyaltyPoints(value);
			Util.verifyAmount(value)
				? setloyaltyPoints(value)
				: setloyaltyPoints(loyaltyPoints);
		}

		if (name === "amountValue") {
			// setamountValue(value);
			Util.verifyAmount(value)
				? setamountValue(value)
				: setamountValue(amountValue);
		}
		if (name === "minimumLoyaltyPointThreshold") {
			// setminimumLoyaltyPointThreshold(value);
			Util.verifyAmount(value)
				? setminimumLoyaltyPointThreshold(value)
				: setminimumLoyaltyPointThreshold(minimumLoyaltyPointThreshold);
		}
	};

	const gateLoyaltyPointOperationsListRes = useSelector(
		({ gateLoyaltyPointOperationsList }) => gateLoyaltyPointOperationsList
	);

	const getLoyaltyPointsListRes = useSelector(
		({ getLoyaltyPointsList }) => getLoyaltyPointsList
	);

	const getLoyaltyPointOperationsList = () => {
		const getLoyaltyPointOperationsListIs = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(
			gateLoyaltyPointOperationsListReq(
				getLoyaltyPointOperationsListIs,
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getLoyaltyPointOperationsList();
		}
	}, [regenerateTokenRes.data.status]);

	const getLoyaltyPointsListRequest = () => {
		setIsLoading(true);
		setGetLoyaltyListStatus(true);
		const getLoyaltyPointOperationsListIs = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				currency: currency,
				operationId: operationName
			}
		};

		return dispatch(
			getLoyaltyPointsListReq(getLoyaltyPointOperationsListIs, authToken)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getLoyaltyPointsListRequest();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (getLoyaltyListStatus) {
			setIsLoading(false);
			if (getLoyaltyPointsListRes.data.status == "success") {
				setGetLoyaltyPointsListArray(
					[].concat(getLoyaltyPointsListRes.data.loyaltyPointsList)
				);
			}
			if (getLoyaltyPointsListRes.data.status == "failed") {
				setGetLoyaltyPointsListArray(getLoyaltyPointsListRes.data);
				if (
					getLoyaltyPointsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getLoyaltyPointsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getLoyaltyPointsListRes.data.status == "Failed") {
				setGetLoyaltyPointsListArray(getLoyaltyPointsListRes.data);
				if (
					getLoyaltyPointsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getLoyaltyPointsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getLoyaltyPointsListRes.data.status == "NOT FOUND") {
				setGetLoyaltyListStatus(false);
			}
		}
	}, [getLoyaltyPointsListRes.data.status]);

	useEffect(() => {
		if (getLoyaltyPointsListRes.data.status == "success") {
			setPage(0);
		}
	}, [getLoyaltyPointsListRes.data.status]);

	const viewData = (
		operationId,
		amountCurrency,
		unitAmount,
		loyaltyPoints,
		amountValue,
		minimumLoyaltyPointThreshold
	) => {
		setoperationId(operationId);
		setamountCurrency(amountCurrency);
		setunitAmount(unitAmount);
		setloyaltyPoints(loyaltyPoints);
		setamountValue(amountValue);
		setminimumLoyaltyPointThreshold(minimumLoyaltyPointThreshold);
		setOpen(true);
	};

	const editData = (
		operationId,
		amountCurrency,
		unitAmount,
		loyaltyPoints,
		amountValue,
		minimumLoyaltyPointThreshold,
		loyaltyPointId
	) => {
		setoperationId(operationId);
		setamountCurrency(amountCurrency);
		setunitAmount(unitAmount);
		setloyaltyPoints(loyaltyPoints);
		setamountValue(amountValue);
		setminimumLoyaltyPointThreshold(minimumLoyaltyPointThreshold);
		setloyaltyPointId(loyaltyPointId);
		setNotificationOpen(true);
	};

	const updateLoyaltyPoint = () => {
		setudateLoyaltyPointStatus(true);
		var data = {};
		data =
			gateLoyaltyPointOperationsListRes.success &&
			[]
				.concat(
					gateLoyaltyPointOperationsListRes.data
						.actionCustomerMasterResponseVOList
				)
				.filter((x) => (x.operationName == operationId ? x.operationId : ""));
		const createOrUpdateLoyaltyPointReqIs = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			settingsRequestVO: {
				action: "UPDATE",
				loyaltyPointId: loyaltyPointId,
				//  operationId: operationId,
				operationId: data[0].operationId,
				amountCurrency: amountCurrency,
				unitAmount: unitAmount,
				loyaltyPoints: loyaltyPoints,
				amountValue: amountValue,
				minimumLoyaltyPointThreshold: minimumLoyaltyPointThreshold
			}
			// loginDetails: {
			//   walletOwnerId: "1",
			// },
			// settingsRequestVO: {
			//   action: "UPDATE", //"Add",
			//   loyaltyPointId: "",
			//   operationId: 2,
			//   amountCurrency: "USD",
			//   unitAmount: "1",
			//   loyaltyPoints: "14",
			//   amountValue: "1",
			//   minimumLoyaltyPointThreshold: "1",
			// },
		};

		return dispatch(
			createOrUpdateLoyaltyPointReq(createOrUpdateLoyaltyPointReqIs, authToken)
		);
	};

	useEffect(() => {
		if (udateLoyaltyPointStatus) {
			if (createOrUpdateLoyaltyPointRes.data.status == "success") {
				setNotificationOpen(false);
				setNotificationOpenSF(true);
				getLoyaltyPointsListRequest();
				setCreateOrUpdateLoyaltyPointResArray(
					createOrUpdateLoyaltyPointRes.data
				);
			}
			if (createOrUpdateLoyaltyPointRes.data.status == "failed") {
				setNotificationOpen(false);
				setNotificationOpenSF(true);
				setCreateOrUpdateLoyaltyPointResArray(
					createOrUpdateLoyaltyPointRes.data
				);
				if (
					createOrUpdateLoyaltyPointRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createOrUpdateLoyaltyPointRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (createOrUpdateLoyaltyPointRes.data.status == "Failed") {
				setNotificationOpen(false);
				setNotificationOpenSF(true);
				setCreateOrUpdateLoyaltyPointResArray(
					createOrUpdateLoyaltyPointRes.data
				);
				if (
					createOrUpdateLoyaltyPointRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createOrUpdateLoyaltyPointRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (createOrUpdateLoyaltyPointRes.data.status == "INVALID REQUEST") {
				setNotificationOpen(false);
				setNotificationOpenSF(true);
				setCreateOrUpdateLoyaltyPointResArray(
					createOrUpdateLoyaltyPointRes.data
				);
				if (
					createOrUpdateLoyaltyPointRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createOrUpdateLoyaltyPointRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}, [createOrUpdateLoyaltyPointRes.data.status]);

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
					>
						{/* <Grid item md={7} sm={12} lg={5}></Grid> */}
						<Grid item md={3} sm={12} xs={12} lg={2}>
							{/* <NavLink to="/index/addNewCustomerWallet">
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#00b9f5", color: "white" }}
                  size="small"
                >
                  Go Back 
                </Button>
              </NavLink> */}
						</Grid>
						<Grid item md={3} sm={12} xs={12} lg={3}>
							<NavLink to="/index/add-loyalty-service">
								{/* <Button
                  variant="contained"
                  style={{ backgroundColor: "#00b9f5", color: "white" }}
                  size="small"
                >
                  Add Loyalty Point
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
								// onClick={getAllWalletsListApi}
								>
									Add Loyalty Point
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem", gap: "20px" }}
					>
						<Grid xs={12} item sm={12} md={4} lg={4}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Operation Type"
								type="name"
								fullWidth
								variant="standard"
								name="operationName"
								// value={operationName || ""}
								defaultValue={"Select OperationType" || operationName}
								onChange={handleChange}
								style={{ marginTop: "0" }}
								className="operationTypeS"

								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem
									value="Select OperationType"
									selected="Select OperationType"
								>
									Select Operation Type
								</MenuItem>
								{gateLoyaltyPointOperationsListRes.success &&
									[]
										.concat(
											gateLoyaltyPointOperationsListRes.data
												.actionCustomerMasterResponseVOList
										)
										.map((x) => (
											<MenuItem value={x.operationId}>
												{x.operationName}
											</MenuItem>
										))}
							</TextField>
						</Grid>

						<Grid xs={12} item sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Currency"
								fullWidth={true}
								name="currency"
								defaultValue={"Select Currency" || currency}
								onChange={handleChange}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{getTransactionCurrencyListRes?.success &&
									getTransactionCurrencyListRes?.data?.status === "success" &&
									[]
										.concat(getTransactionCurrencyListRes.data.currencyList)
										.map((x) => <MenuItem value={x} key={x}>{x}</MenuItem>)
								}
							</TextField>
						</Grid>

						<Grid xs={12} item sm={12} md={3} lg={3}>
							{/* <Button
                style={{
                  // marginLeft: "2.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                  marginTop: "5px",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getLoyaltyPointsListRequest}
              >
                Search
              </Button> */}
							<CustomButton
								className="searchBtnD"
								style={{
									padding: "8px"
								}}


								onClick={getLoyaltyPointsListRequest}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>

					{/* <Grid
            container
            style={{
              padding: "10px",
              marginTop: "1.5rem",
              marginBottom: "15px",
            }}
          >
            <Grid item md={5}>
              <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getLoyaltyPointsListRequest}
              >
                Search
              </Button>
            </Grid>
            <Grid item md={7}></Grid>
          </Grid> */}
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getLoyaltyPointsListArray.length == undefined ||
					!getLoyaltyListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Loyalty Point Details
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Loyalty Point Details
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table>
									<TableHead>
										<TableRow className="tableHeaderColor">
											{/* <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Sr.No </TableCell> */}
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Operation
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getLoyaltyPointsListArray &&
											[]
												.concat(getLoyaltyPointsListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														{/* <TableCell align="center">{index}</TableCell> */}
														<TableCell align="center">
															{row.operationId}
														</TableCell>
														<TableCell align="center">
															{row.amountCurrency}
														</TableCell>

														<TableCell align="center">
															<Tooltip title="View">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		viewData(
																			row.operationId,
																			row.amountCurrency,
																			row.unitAmount,
																			row.loyaltyPoints,
																			row.amountValue,
																			row.minimumLoyaltyPointThreshold
																		)
																	}
																>
																	{/* View */}
																	{
																		<VisibilityIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>

															<Tooltip title="Edit">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		editData(
																			row.operationId,
																			row.amountCurrency,
																			row.unitAmount,
																			row.loyaltyPoints,
																			row.amountValue,
																			row.minimumLoyaltyPointThreshold,
																			row.loyaltyPointId
																		)
																	}
																>
																	{/* Update */}
																	{
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={[].concat(getLoyaltyPointsListArray).length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}

				<div>
					<Dialog open={open} onClose={handleClose}>
						<DialogTitle>Loyalty Point Management</DialogTitle>
						<DialogContent>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Operation Type"
								type="name"
								fullWidth
								variant="standard"
								value={operationId || ""}
								disabled
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Currency"
								type="name"
								fullWidth
								variant="standard"
								value={amountCurrency || ""}
								disabled
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Amount Unit"
								type="name"
								fullWidth
								variant="standard"
								value={unitAmount || ""}
								disabled
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Loyalty Points"
								type="name"
								fullWidth
								variant="standard"
								value={loyaltyPoints || ""}
								disabled
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Amount Value"
								type="name"
								fullWidth
								variant="standard"
								value={amountValue || ""}
								disabled
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Minimum Threshold"
								type="name"
								fullWidth
								variant="standard"
								value={minimumLoyaltyPointThreshold}
								disabled
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</DialogContent>
						<DialogActions>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Close
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Close
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>

				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogTitle>Loyalty Point Management</DialogTitle>
						<DialogContent>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Operation Type"
								required
								type="name"
								fullWidth
								variant="standard"
								value={operationId || ""} //operationId
								name="operationId"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{gateLoyaltyPointOperationsListRes.success &&
									[]
										.concat(
											gateLoyaltyPointOperationsListRes.data
												.actionCustomerMasterResponseVOList
										)
										.map((x) => (
											<MenuItem value={x.operationName}>
												{x.operationName}
											</MenuItem>
										))}
							</TextField>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Currency"
								required
								type="name"
								fullWidth
								variant="standard"
								value={amountCurrency || ""}
								name="amountCurrency"
								onChange={handleChange}
							>
								{getTransactionCurrencyListRes?.success &&
									getTransactionCurrencyListRes?.data?.status === "success" &&
									[]
										.concat(getTransactionCurrencyListRes.data.currencyList || [])
										.map((x) => <MenuItem value={x} key={x}>{x}</MenuItem>)
								}
							</TextField>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Amount Unit"
								required
								type="text"
								fullWidth
								variant="standard"
								value={unitAmount || ""}
								name="unitAmount"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Loyalty Points"
								required
								type="text"
								fullWidth
								variant="standard"
								value={loyaltyPoints || ""}
								name="loyaltyPoints"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Amount Value"
								required
								type="text"
								fullWidth
								variant="standard"
								value={amountValue || ""}
								name="amountValue"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Minimum Threshold"
								required
								type="text"
								fullWidth
								variant="standard"
								value={minimumLoyaltyPointThreshold}
								name="minimumLoyaltyPointThreshold"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</DialogContent>
						<DialogActions>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Close
							</Button>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={updateLoyaltyPoint}
							>
								Save
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={updateLoyaltyPoint}
							>
								Save
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>

				{createOrUpdateLoyaltyPointResArray.status == "failed" && (
					<div>
						<Dialog open={notificationOpenSF} onClose={handleNoticationCloseSF}>
							<DialogContent
								className="text-center popupBackgroundColor"
							// style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h3
									style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
								>
									{createOrUpdateLoyaltyPointResArray.description}
								</h3>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationCloseSF}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationCloseSF}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}

				{createOrUpdateLoyaltyPointResArray.status == "Failed" && (
					<div>
						<Dialog open={notificationOpenSF} onClose={handleNoticationCloseSF}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h3
									style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
								>
									{createOrUpdateLoyaltyPointResArray.description}
								</h3>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationCloseSF}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationCloseSF}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}

				{createOrUpdateLoyaltyPointResArray.status == "success" && (
					<div>
						<Dialog open={notificationOpenSF} onClose={handleNoticationCloseSF}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={success} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h3
									style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
								>
									{createOrUpdateLoyaltyPointResArray.description}
								</h3>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationCloseSF}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationCloseSF}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}

				{createOrUpdateLoyaltyPointResArray.status == "INVALID REQUEST" && (
					<div>
						<Dialog open={notificationOpenSF} onClose={handleNoticationCloseSF}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h3
									style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
								>
									{createOrUpdateLoyaltyPointResArray.description}
								</h3>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationCloseSF}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationCloseSF}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}

			</Layout>
		</>
	);
};

export default LoyalPoints;
